export default {
  "wt-native-select": "_wt-native-select_1aiwb8b_1",
  "wt-native-select__select": "_wt-native-select__select_1aiwb8b_5",
  "wt-native-select__select_size_m": "_wt-native-select__select_size_m_1aiwb8b_19",
  "wt-native-select__select_size_s": "_wt-native-select__select_size_s_1aiwb8b_28",
  "wt-native-select__select_size_xs": "_wt-native-select__select_size_xs_1aiwb8b_37"
};